module.exports = __webpack_public_path__ + "static/media/ObjectiveBullBear_IPOIntelligence.3ab089e7.png";